import gql from 'graphql-tag';

export default gql`
  mutation clearDraftInteraction($contentId: UUID!) {
    me {
      clearDraftInteraction(contentId: $contentId)
    }
  }
`;
